// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CourseModule } from './courseModule';
import type { ModuleLecturerResponse } from './moduleLecturerResponse';

export type GenericApiResponseListUnionCourseModuleModuleLecturerResponseDataAnyOfItem =
  | CourseModule
  | ModuleLecturerResponse;
